import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { PublicSiteService } from '../../Services/PublicSiteService';
import PublicSiteEditMember from '../../Pages/PublicSite/PublicSiteEditMember';
import PublicSiteEditFamilyMember from '../../Pages/PublicSite/PublicSiteEditFamilyMember';

/**
 * `/:companyurl/editmember` landing. Decides - from the member's session - whether to render the
 * full member self-edit page or the reduced family-member one, and redirects to login when there
 * is no session. This is the single place the two public-site self-edit flows meet.
 */
export const PublicSiteMemberLanding = () => {
    const params = useParams();
    const location = useLocation();
    const [checking, setChecking] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);
    const [isFamilyMember, setIsFamilyMember] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const check = async () => {
            try {
                const session = await PublicSiteService.GetSession();
                if (isMounted) {
                    setAuthenticated(true);
                    setIsFamilyMember(!!session.isFamilyMember);
                }
            } catch {
                if (isMounted) {
                    setAuthenticated(false);
                }
            } finally {
                if (isMounted) {
                    setChecking(false);
                }
            }
        };

        check();

        return () => {
            isMounted = false;
        };
    }, [params.companyurl]);

    if (checking) {
        return (
            <div style={{ textAlign: 'center', padding: '100px' }}>
                <Spin size='large' />
            </div>
        );
    }

    if (!authenticated) {
        const language = getCurrentLanguage();
        const companyUrl = params.companyurl;

        if (!companyUrl) {
            return <Navigate to={`/${language}/`} replace />;
        }

        return (
            <Navigate
                to={`/${language}/${companyUrl}/login`}
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    return isFamilyMember
        ? <PublicSiteEditFamilyMember />
        : <PublicSiteEditMember />;
};
